var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66602 7.16669L16.3327 7.16669M9.66602 7.16669C9.66602 6.24621 8.91982 5.5 7.99935 5.5C7.07887 5.5 6.33333 6.24621 6.33333 7.16669M9.66602 7.16669C9.66602 8.08716 8.91982 8.83333 7.99935 8.83333C7.07887 8.83333 6.33333 8.08716 6.33333 7.16669M3 7.16669L6.33333 7.16669M13.832 14.5H16.332M13.832 14.5C13.832 13.5795 13.0858 12.8333 12.1654 12.8333C11.2449 12.8333 10.4987 13.5795 10.4987 14.5C10.4987 15.4205 11.2449 16.1667 12.1654 16.1667C13.0858 16.1667 13.832 15.4205 13.832 14.5ZM3 14.5L9.66667 14.5",
    stroke: "#110D28",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.22d93669a03e815e6c17d19584b19aef.svg";
export { ForwardRef as ReactComponent };